import React, { FC } from 'react';
import { TAppointment } from '@api/appointments/types';

export const physicianFormatter: FC<TAppointment> = (appointment) => {
  const currentPhysician = appointment.trials.physicians;

  return <ul>{currentPhysician.name}</ul>;
};
